import { render, staticRenderFns } from "./der-ord.vue?vue&type=template&id=57e2216c&scoped=true"
import script from "./der-ord.vue?vue&type=script&lang=js"
export * from "./der-ord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e2216c",
  null
  
)

export default component.exports